(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["voice-of-venue-acc-amberg-story"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('.vov-amberg__visuals');
    const lightbox = document.querySelector('.vov-amberg__lightbox');
    if (!root || !lightbox) return;
    const image = lightbox.querySelector('img');
    const close = lightbox.querySelector('.vov-amberg__lightbox-close');
    const previous = lightbox.querySelector('.vov-amberg__lightbox-prev');
    const next = lightbox.querySelector('.vov-amberg__lightbox-next');
    const items = Array.from(root.querySelectorAll('[data-vov-amberg-image]'));
    let activeIndex = 0;
    const showImage = (index) => {
      activeIndex = (index + items.length) % items.length;
      const trigger = items[activeIndex];
      const thumbnail = trigger.querySelector('img');
      image.src = trigger.dataset.vovAmbergImage;
      image.alt = thumbnail ? thumbnail.alt : '';
    };
    root.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-vov-amberg-image]');
      if (!trigger) return;
      showImage(items.indexOf(trigger));
      lightbox.showModal();
    });
    previous.addEventListener('click', () => showImage(activeIndex - 1));
    next.addEventListener('click', () => showImage(activeIndex + 1));
    close.addEventListener('click', () => lightbox.close());
    lightbox.addEventListener('click', (event) => {
      if (event.target === lightbox) lightbox.close();
    });
    lightbox.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') showImage(activeIndex - 1);
      if (event.key === 'ArrowRight') showImage(activeIndex + 1);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["voice-of-venue-christchurch-baptist-story"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('.vov-christchurch__visuals');
    const lightbox = document.querySelector('.vov-christchurch__lightbox');
    if (!root || !lightbox) return;
    const image = lightbox.querySelector('img');
    const close = lightbox.querySelector('.vov-christchurch__lightbox-close');
    const previous = lightbox.querySelector('.vov-christchurch__lightbox-prev');
    const next = lightbox.querySelector('.vov-christchurch__lightbox-next');
    const items = Array.from(root.querySelectorAll('[data-vov-christchurch-image]'));
    let activeIndex = 0;
    const showImage = (index) => {
      activeIndex = (index + items.length) % items.length;
      const trigger = items[activeIndex];
      const thumbnail = trigger.querySelector('img');
      image.src = trigger.dataset.vovChristchurchImage;
      image.alt = thumbnail ? thumbnail.alt : '';
    };
    root.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-vov-christchurch-image]');
      if (!trigger) return;
      showImage(items.indexOf(trigger));
      lightbox.showModal();
    });
    previous.addEventListener('click', () => showImage(activeIndex - 1));
    next.addEventListener('click', () => showImage(activeIndex + 1));
    close.addEventListener('click', () => lightbox.close());
    lightbox.addEventListener('click', (event) => {
      if (event.target === lightbox) lightbox.close();
    });
    lightbox.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') showImage(activeIndex - 1);
      if (event.key === 'ArrowRight') showImage(activeIndex + 1);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["voice-of-venue-doss-story"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('.vov-doss__visuals');
    const lightbox = document.querySelector('.vov-doss__lightbox');
    if (!root || !lightbox) return;
    const image = lightbox.querySelector('img');
    const close = lightbox.querySelector('.vov-doss__lightbox-close');
    const previous = lightbox.querySelector('.vov-doss__lightbox-prev');
    const next = lightbox.querySelector('.vov-doss__lightbox-next');
    const items = Array.from(root.querySelectorAll('[data-vov-doss-image]'));
    previous.hidden = items.length < 2;
    next.hidden = items.length < 2;
    let activeIndex = 0;
    const showImage = (index) => {
      activeIndex = (index + items.length) % items.length;
      const trigger = items[activeIndex];
      const thumbnail = trigger.querySelector('img');
      image.src = trigger.dataset.vovDossImage;
      image.alt = thumbnail ? thumbnail.alt : '';
    };
    root.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-vov-doss-image]');
      if (!trigger) return;
      showImage(items.indexOf(trigger));
      lightbox.showModal();
    });
    previous.addEventListener('click', () => showImage(activeIndex - 1));
    next.addEventListener('click', () => showImage(activeIndex + 1));
    close.addEventListener('click', () => lightbox.close());
    lightbox.addEventListener('click', (event) => {
      if (event.target === lightbox) lightbox.close();
    });
    lightbox.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') showImage(activeIndex - 1);
      if (event.key === 'ArrowRight') showImage(activeIndex + 1);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["voice-of-venue-greenwich-story"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('.vov-greenwich__visuals');
    const lightbox = document.querySelector('.vov-greenwich__lightbox');
    if (!root || !lightbox) return;
    const image = lightbox.querySelector('img');
    const close = lightbox.querySelector('.vov-greenwich__lightbox-close');
    const previous = lightbox.querySelector('.vov-greenwich__lightbox-prev');
    const next = lightbox.querySelector('.vov-greenwich__lightbox-next');
    const items = Array.from(root.querySelectorAll('[data-vov-greenwich-image]'));
    let activeIndex = 0;
    const showImage = (index) => {
      activeIndex = (index + items.length) % items.length;
      const trigger = items[activeIndex];
      const thumbnail = trigger.querySelector('img');
      image.src = trigger.dataset.vovGreenwichImage;
      image.alt = thumbnail ? thumbnail.alt : '';
    };
    root.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-vov-greenwich-image]');
      if (!trigger) return;
      showImage(items.indexOf(trigger));
      lightbox.showModal();
    });
    previous.addEventListener('click', () => showImage(activeIndex - 1));
    next.addEventListener('click', () => showImage(activeIndex + 1));
    close.addEventListener('click', () => lightbox.close());
    lightbox.addEventListener('click', (event) => {
      if (event.target === lightbox) lightbox.close();
    });
    lightbox.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') showImage(activeIndex - 1);
      if (event.key === 'ArrowRight') showImage(activeIndex + 1);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["voice-of-venue-salem-story"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('.vov-salem__visuals');
    const lightbox = document.querySelector('.vov-salem__lightbox');
    if (!root || !lightbox) return;
    const image = lightbox.querySelector('img');
    const close = lightbox.querySelector('.vov-salem__lightbox-close');
    const previous = lightbox.querySelector('.vov-salem__lightbox-prev');
    const next = lightbox.querySelector('.vov-salem__lightbox-next');
    const items = Array.from(root.querySelectorAll('[data-vov-salem-image]'));
    previous.hidden = items.length < 2;
    next.hidden = items.length < 2;
    let activeIndex = 0;
    const showImage = (index) => {
      activeIndex = (index + items.length) % items.length;
      const trigger = items[activeIndex];
      const thumbnail = trigger.querySelector('img');
      image.src = trigger.dataset.vovSalemImage;
      image.alt = thumbnail ? thumbnail.alt : '';
    };
    root.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-vov-salem-image]');
      if (!trigger) return;
      showImage(items.indexOf(trigger));
      lightbox.showModal();
    });
    previous.addEventListener('click', () => showImage(activeIndex - 1));
    next.addEventListener('click', () => showImage(activeIndex + 1));
    close.addEventListener('click', () => lightbox.close());
    lightbox.addEventListener('click', (event) => {
      if (event.target === lightbox) lightbox.close();
    });
    lightbox.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') showImage(activeIndex - 1);
      if (event.key === 'ArrowRight') showImage(activeIndex + 1);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
